import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { HandlingCertificationTableFilterSchema } from '../../../../-components/HandlingCertificationList/-zod-schema';

export const Route = createFileRoute(
  '/_staff/certification/specialty-certification/$id/_layout/handling-certifications/',
)({
  validateSearch: zodValidator(HandlingCertificationTableFilterSchema),
});
